export class CompanyData {

    private companyCode: string;
    private companyImage: string;
    private companyName: string;

    constructor(companyName?: string, companyImage?: string) {
        this.companyName = companyName;
        this.companyImage = companyImage;
    }

    public get CompanyCode(): string {
        return this.companyCode;
    }

    public set CompanyCode(companyCode: string) {
        this.companyCode = companyCode;
    }

    public get CompanyImage(): string {
        return this.companyImage;
    }

    public set CompanyImage(companyImage: string) {
        this.companyImage = companyImage;
    }

    public get CompanyName(): string {
        return this.companyName;
    }

    public set CompanyName(companyName: string) {
        this.companyName = companyName;
    }
}
